import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export default function InstagramIcon(t0) {
  const $ = _c(16);
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      width: t1,
      height: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = t1;
    $[3] = t2;
  } else {
    props = $[1];
    t1 = $[2];
    t2 = $[3];
  }
  const width = t1 === undefined ? 28 : t1;
  const height = t2 === undefined ? 28 : t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path d="M14.03 28h-.06C6.266 28 0 21.733 0 14.03v-.06C0 6.266 6.267 0 13.97 0h.06C21.734 0 28 6.267 28 13.97v.06C28 21.734 21.733 28 14.03 28zM13.97.948C6.788.948.947 6.788.947 13.969v.062c0 7.18 5.84 13.021 13.021 13.021h.062c7.18 0 13.021-5.84 13.021-13.021v-.062c0-7.18-5.84-13.021-13.021-13.021h-.062z" fill="url(#paint0_linear_147_1281)" />;
    t4 = <path d="M18.186 5.978h-8.37a4.199 4.199 0 00-4.195 4.194v7.657a4.199 4.199 0 004.194 4.194h8.37a4.199 4.199 0 004.195-4.194v-7.658a4.199 4.199 0 00-4.194-4.193zM7.1 10.172a2.718 2.718 0 012.714-2.715h8.37a2.718 2.718 0 012.715 2.715v7.657a2.718 2.718 0 01-2.714 2.715h-8.37A2.718 2.718 0 017.1 17.829v-7.658z" fill="url(#paint1_linear_147_1281)" />;
    t5 = <path d="M14 17.9c2.151 0 3.902-1.749 3.902-3.9A3.905 3.905 0 0014 10.098 3.905 3.905 0 0010.1 14a3.905 3.905 0 003.9 3.902zm0-6.321A2.424 2.424 0 0116.423 14a2.424 2.424 0 01-2.421 2.422 2.424 2.424 0 01-2.422-2.421 2.424 2.424 0 012.422-2.422z" fill="url(#paint2_linear_147_1281)" />;
    t6 = <path d="M18.263 10.729a1.052 1.052 0 000-2.102 1.052 1.052 0 000 2.102z" fill="url(#paint3_linear_147_1281)" />;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <linearGradient id="paint0_linear_147_1281" x1={4.09627} y1={23.9037} x2={23.9037} y2={4.09627} gradientUnits="userSpaceOnUse"><stop stopColor="#000" /><stop offset={0.35} stopColor="#000" /><stop offset={0.62} stopColor="#000" /><stop offset={1} stopColor="#000" /></linearGradient>;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <linearGradient id="paint1_linear_147_1281" x1={7.02872} y1={20.9713} x2={20.9714} y2={7.02963} gradientUnits="userSpaceOnUse"><stop stopColor="#000" /><stop offset={0.35} stopColor="#000" /><stop offset={0.62} stopColor="#000" /><stop offset={1} stopColor="#000" /></linearGradient>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <linearGradient id="paint2_linear_147_1281" x1={11.2435} y1={16.7576} x2={16.7567} y2={11.2434} gradientUnits="userSpaceOnUse"><stop stopColor="#000" /><stop offset={0.35} stopColor="#000" /><stop offset={0.62} stopColor="#000" /><stop offset={1} stopColor="#000" /></linearGradient>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <defs>{t7}{t8}{t9}<linearGradient id="paint3_linear_147_1281" x1={17.5196} y1={10.4208} x2={19.0057} y2={8.93467} gradientUnits="userSpaceOnUse"><stop stopColor="#000" /><stop offset={0.35} stopColor="#000" /><stop offset={0.62} stopColor="#000" /><stop offset={1} stopColor="#000" /></linearGradient></defs>;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== height || $[13] !== props || $[14] !== width) {
    t11 = <svg width={width} height={height} viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>{t3}{t4}{t5}{t6}{t10}</svg>;
    $[12] = height;
    $[13] = props;
    $[14] = width;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  return t11;
}